// ── useLastTraceId — DEBUG-ONLY hook ─────────────────────────────────────────
//
// Returns the trace_id of the most recent traced API call pushed via
// `trackTraceId`, or null. This is intentionally process-global "last seen"
// state.
//
// ⚠️  NOT THE PRODUCT PATH FOR FEEDBACK. ⚠️
//
// Under concurrent requests, streaming responses, retries, or multiple chat
// tabs, a global "last trace_id" is untrustworthy — a user could thumb-up
// message A while this hook points at message B, attaching feedback to the
// wrong trace. The correct pattern is to thread `trace_id` through the
// message object itself (e.g. `message.trace_id`) and read it via props on
// the FeedbackButton next to that specific message.
//
// This hook exists ONLY for dev tooling / error reporting where "what was the
// last trace this tab produced" is a useful debugging signal.
//
// Ref: PRID v3 / ASC-4482.

import { useObservability } from './ObservabilityProvider';

/**
 * DEBUG-ONLY. Returns the trace_id of the most recent `trackTraceId` call in
 * this provider scope, or null. Do not wire this into feedback submission —
 * use `message.trace_id` threaded through props instead.
 */
export function useLastTraceId() {
  const {
    lastTraceId
  } = useObservability();
  return lastTraceId ?? null;
}